import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import Flex from '@magalu/stereo-ui/atoms/Flex';
import styled from 'styled-components';
export var ContentInfo = styled(Flex)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex-direction: column;\n  padding-bottom: 16px;\n  gap: 20px;\n"])));